import React, { useMemo, useContext } from 'react';
import { ContainerModalItems } from './styles';
import Input from '../../Input';
import { ButtonPrimary, Spinner } from '../../StyledComponent';
import ModalBanner from '../../ModalBanner';
import { useState } from 'react';
import { maskPhone } from '../../../Utils/masks';
import { validarEmail, validarTelefone } from '../../../Utils/validations';
import { indiqueGanhe } from '../../../services/indiqueGanhe';
import { ContextGetData } from '../../../services/getData';

function ModalIndicacao({
  urlRegulament,
  tema,
  closeModal,
  showSuccessModal,
  showErrorModal,
}) {
  const [userData, setUserData] = useState({
    firstName: { value: '', isValid: '' },
    lastName: { value: '', isValid: '' },
    email: { value: '', isValid: '' },
    phone: { value: '', isValid: '' },
  });
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [loading, setLoading] = useState(false);
  const { idSalesForce: accountId } = useContext(ContextGetData);

  function setValue(e, mask) {
    const { id, value } = e.target;

    const valueTreated = mask ? mask(value) : value;

    setUserData({
      ...userData,
      [id]: { ...userData[id], value: valueTreated },
    });
  }

  function ValidateFields(e) {
    const { id } = e.target;
    const value = userData[id]?.value;
    let isValid = false;
    switch (id) {
      case 'firstName':
      case 'lastName':
        isValid = !!value?.trim();
        break;
      case 'email':
        isValid = validarEmail(value);
        break;
      case 'phone':
        isValid = validarTelefone(value);
        break;
    }

    setUserData({ ...userData, [id]: { ...userData[id], isValid } });
  }

  function handleClickAcceptTerms(e) {
    setAcceptedTerms(e.target.checked);
  }

  async function submit() {
    setLoading(true);

    const { firstName, lastName, email, phone } = userData;

    const userDataToSend = {
      accountId,
      firstName: firstName?.value,
      lastName: lastName?.value,
      email: email?.value,
      phone: phone?.value?.replace(/\D/g, ''),
    };

    const success = await indiqueGanhe(userDataToSend);

    closeModal();

    if (success) {
      showSuccessModal();
    } else {
      showErrorModal();
    }
  }

  const areAllFieldsValid = useMemo(() => {
    const valuesOfObject = Object.values(userData);
    let hasSomeInvalid = valuesOfObject.some(({ isValid }) => !isValid);
    return !hasSomeInvalid;
  }, [userData]);

  const disableSubmitButton = !areAllFieldsValid || !acceptedTerms || loading;

  return (
    <ModalBanner showBanner>
      <ContainerModalItems tema={tema}>
        <span className='title'>Quem você deseja indicar?</span>

        <div className='inputs-container'>
          <Input
            id='firstName'
            labelName={'Nome'}
            placeholder={'Digite o nome'}
            handleInputChange={setValue}
            marginTop={0}
            value={userData?.firstName?.value}
            error={userData?.firstName?.isValid === false}
            errorMessage={'Digite um nome válido'}
            onBlur={ValidateFields}
          />
          <Input
            id='lastName'
            labelName={'Sobrenome'}
            placeholder={'Digite o sobrenome'}
            marginTop={0}
            handleInputChange={setValue}
            value={userData?.lastName?.value}
            error={userData?.lastName?.isValid === false}
            errorMessage={'Digite um sobrenome válido'}
            onBlur={ValidateFields}
          />
          <Input
            id='email'
            labelName={'E-mail'}
            placeholder={'Digite o e-mail'}
            marginTop={0}
            handleInputChange={setValue}
            value={userData?.email?.value}
            error={userData?.email?.isValid === false}
            errorMessage={'Digite um email válido'}
            onBlur={ValidateFields}
          />
          <Input
            id='phone'
            labelName={'Telefone'}
            placeholder={'(DDD) + Telefone'}
            marginTop={0}
            handleInputChange={(e) => setValue(e, maskPhone)}
            error={userData?.phone?.isValid === false}
            errorMessage={'Digite um telefone válido'}
            value={userData?.phone?.value}
            onBlur={ValidateFields}
          />

          <div className='terms-container'>
            <label>
              <input
                type='checkbox'
                value={acceptedTerms}
                onChange={handleClickAcceptTerms}
              />
              <span>
                Entendi e concordo com o{' '}
                <a href={urlRegulament} target='_blank' rel='noreferrer'>
                  Regulamento da campanha
                </a>
              </span>
            </label>
          </div>
        </div>
        <div className='container-buttons'>
          <ButtonPrimary
            tema={tema}
            fullWidth
            disabled={disableSubmitButton}
            onClick={submit}
          >
            INDICAR
            {loading && <Spinner />}
          </ButtonPrimary>
          <ButtonPrimary tema={tema} light fullWidth onClick={closeModal}>
            CANCELAR
          </ButtonPrimary>
        </div>
      </ContainerModalItems>
    </ModalBanner>
  );
}

export default ModalIndicacao;
